(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nut-watch-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nut-watch-shop')) {
  customElements.define('nut-watch-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.nut-watch-track');
      this.cards = [...this.querySelectorAll('.nut-watch-card')];
      this.videos = [...this.querySelectorAll('.nut-watch-card video')];
      this.filters = [...this.querySelectorAll('[data-group]')];
      this.empty = this.querySelector('.nut-watch-empty-group');
      this.status = this.querySelector('.nut-watch-status');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.videoVisible = new Map();
      this.animations = new Map();
      this.activeGroup = 'all';
      this.products = new Map();
      this.setupProducts(signal);
      this.setupViewer(signal);
      this.motion = () => this.dataset.animate === 'true' && !this.reduced.matches;
      this.visibleCards = () => this.cards.filter(card => !card.hidden);
      this.reveal = (card, index = 0, replay = false) => {
        if (card.hidden || (!replay && !card.classList.contains('is-pending'))) return;
        card.classList.remove('is-pending');
        this.animations.get(card)?.cancel();
        if (this.motion()) {
          const animation = card.animate([{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}], {duration:480,delay:Math.min(index * 60,240),easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});
          this.animations.set(card, animation);
        }
      };
      this.updateLayout = () => {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const available = Math.max(1,(this.track.parentElement?.clientWidth || this.track.clientWidth) - 4);
        const columns = innerWidth <= 1023 ? 3 : Number(this.dataset.columns) || 4;
        const size = innerWidth <= 768 ? Math.min(innerWidth * .72,300) : this.dataset.fill === 'true' ? (available - gap * (columns - 1)) / columns : parseFloat(this.style.getPropertyValue('--nut-watch-width')) || 240;
        this.style.setProperty('--nut-watch-size',`${size}px`);
        const count = this.visibleCards().length;
        this.track.classList.toggle('is-centered',innerWidth > 768 && count * size + Math.max(0,count - 1) * gap <= available + 1);
        this.updateNav();
      };
      this.updateNav = () => {
        const visible = this.visibleCards();
        const box = this.track.getBoundingClientRect();
        const first = visible[0]?.getBoundingClientRect();
        const last = visible.at(-1)?.getBoundingClientRect();
        const rtl = this.dir === 'rtl';
        this.querySelector('[data-step="-1"]').disabled = !first || (rtl ? first.right <= box.right + 3 : first.left >= box.left - 3);
        this.querySelector('[data-step="1"]').disabled = !last || (rtl ? last.left >= box.left - 3 : last.right <= box.right + 3);
      };
      this.setPlayState = video => {
        const button=video.parentElement.querySelector('[data-play]');
        button.setAttribute('aria-label',button.dataset.playLabel);
        button.querySelector('span').textContent='▶';
      };
      this.syncPlayback = video => {
        const allowed = !this.viewer?.open && !video.closest('.nut-watch-card').hidden && this.videoVisible.get(video) && !document.hidden && !this.track.classList.contains('is-filtering') && !document.querySelector('#hdt-quick-add-modal[open]') && !this.products.get(video.closest('.nut-watch-card'))?.busy;
        const wantsPlay = video.dataset.manual === 'play' || (video.dataset.manual !== 'pause' && this.dataset.autoplay === 'true' && !this.reduced.matches);
        if (allowed && wantsPlay && !video.error) {
          if (!video.getAttribute('src')) {video.src = video.dataset.src;video.load();}
          video.play().catch(() => this.setPlayState(video,false));
        } else video.pause();
      };
      this.applyGroup = (group, animate = true) => {
        if(this.viewer?.open)this.viewer.close();
        this.activeGroup = group;
        this.products.forEach(state => this.closeProduct(state,true));
        const visible = [];
        this.cards.forEach(card => {
          this.animations.get(card)?.cancel();
          card.hidden = group !== 'all' && !card.dataset.groups.split(/\s+/).includes(group);
          const video = card.querySelector('video');
          if (video) {video.pause();this.videoVisible.set(video,false);this.visibleObserver.unobserve(card);this.visibleObserver.observe(card);}
          if (!card.hidden) visible.push(card);
        });
        this.filters.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.group === group)));
        this.empty.hidden = visible.length > 0;
        this.track.hidden = visible.length === 0;
        this.track.scrollTo({left:0,behavior:'instant'});
        this.track.classList.remove('is-filtering');
        if (animate) visible.forEach((card,index) => {
          const box = card.getBoundingClientRect();
          if (box.top < innerHeight && box.bottom > 0) this.reveal(card,index,true);
        });
        this.status.textContent = `${visible.length} ${this.status.dataset.resultLabel}`;
        this.updateLayout();
      };
      this.selectGroup = group => {
        clearTimeout(this.filterTimer);
        this.videos.forEach(video => video.pause());
        if (this.motion()) {
          this.track.classList.add('is-filtering');
          this.filterTimer = setTimeout(() => this.applyGroup(group),120);
        } else this.applyGroup(group,false);
      };
      this.filters.forEach(button => button.addEventListener('click', () => this.selectGroup(button.dataset.group), {signal}));
      this.querySelector('[data-show-all]').addEventListener('click', () => {this.selectGroup('all');this.filters[0].focus();}, {signal});
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        const step = Number(button.dataset.step) * (this.dir === 'rtl' ? -1 : 1);
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({left:step * ((this.visibleCards()[0]?.getBoundingClientRect().width || 240) + gap),behavior:this.reduced.matches ? 'instant' : 'smooth'});
      }, {signal}));
      this.track.addEventListener('scroll', this.updateNav, {passive:true,signal});
      this.resize = new ResizeObserver(this.updateLayout);
      this.resize.observe(this.track);
      this.videos.forEach(video => {
        video.muted = true;
        const start = Math.max(0,Number(video.dataset.start) || 0);
        const length = Math.min(9,Math.max(2,Number(video.dataset.length) || 8));
        video.addEventListener('loadedmetadata', () => {
          const from = Math.min(start,Math.max(0,video.duration - .5));
          video.dataset.effectiveStart = from;
          video.currentTime = from;
        }, {signal});
        video.addEventListener('timeupdate', () => {
          const from = Number(video.dataset.effectiveStart) || 0;
          if (video.currentTime >= Math.min(from + length,video.duration)) video.currentTime = from;
        }, {signal});
        video.addEventListener('loadeddata', () => video.setAttribute('data-ready',''), {signal});
        video.addEventListener('play', () => this.setPlayState(video,true), {signal});
        video.addEventListener('pause', () => this.setPlayState(video,false), {signal});
        video.addEventListener('error', () => {
          video.pause();video.removeAttribute('data-ready');
          video.parentElement.querySelector('[data-play]').hidden = true;
          video.parentElement.querySelector('.nut-watch-video-error').hidden = false;
        }, {signal});
        video.parentElement.querySelector('[data-play]').addEventListener('click', event => {
          this.openViewer(video.closest('.nut-watch-card'),event.currentTarget);
        }, {signal});
      });
      this.visibleObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        const video = entry.target.querySelector('video');
        if (video) {this.videoVisible.set(video,!entry.target.hidden && entry.isIntersecting && entry.intersectionRatio >= .4);this.syncPlayback(video);}
      }), {threshold:[0,.4,.6]});
      this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.hidden) this.reveal(entry.target,Math.max(0,this.visibleCards().indexOf(entry.target)));
      }), {threshold:.08});
      this.cards.forEach(card => {if(this.motion()) card.classList.add('is-pending');this.visibleObserver.observe(card);this.revealObserver.observe(card);});
      document.addEventListener('visibilitychange', () => this.videos.forEach(this.syncPlayback), {signal});

      const modal = document.querySelector('#hdt-quick-add-modal');
      if (modal) {this.modalObserver = new MutationObserver(() => this.videos.forEach(this.syncPlayback));this.modalObserver.observe(modal,{attributes:true,attributeFilter:['open']});}
      this.reduced.addEventListener('change', () => {if(this.reduced.matches){this.animations.forEach(animation=>animation.cancel());this.cards.forEach(card=>card.classList.remove('is-pending'));}this.videos.forEach(this.syncPlayback);}, {signal});
      this.addEventListener('shopify:block:select', event => {clearTimeout(this.filterTimer);this.applyGroup('all',false);event.target.classList.remove('is-pending');event.target.scrollIntoView({behavior:'instant',block:'nearest',inline:'nearest'});}, {signal});
      this.dataset.enhanced = 'true';this.dataset.motionReady = 'true';this.updateLayout();
    }
    setupViewer(signal) {
      this.viewer = this.querySelector('.nut-watch-dialog');
      this.viewerVideo = this.viewer.querySelector('[data-viewer-video]');
      this.viewerMedia = this.viewer.querySelector('[data-viewer-media]');
      this.viewerMuted = true;
      this.viewerPlaying = true;
      this.viewer.addEventListener('click', event => {
        if (event.target === this.viewer || event.target.closest('[data-viewer-close]')) this.viewer.close();
        const step = event.target.closest('[data-viewer-step]');
        if (step) this.stepViewer(Number(step.dataset.viewerStep));
        if (event.target.closest('[data-viewer-sound]')) {
          this.viewerMuted = !this.viewerMuted;
          this.viewerVideo.muted = this.viewerMuted;
          this.updateViewerSound();
          this.viewerPlaying = true;
          this.syncViewerPlayback();
        }
        if (event.target === this.viewerVideo || event.target.closest('[data-viewer-play]')) {
          this.viewerPlaying = this.viewerVideo.paused;
          this.syncViewerPlayback();
        }
      }, {signal});
      this.viewer.addEventListener('close', () => {
        this.viewerVideo.pause();
        this.restoreViewerProduct();
        this.viewerCard = null;
        this.viewerVideo.removeAttribute('src');
        this.viewerVideo.load();
        document.body.style.overflow = this.viewerScrollLock || '';
        this.viewerOpener?.focus({preventScroll:true});
        this.videos.forEach(this.syncPlayback);
      }, {signal});
      this.viewer.addEventListener('cancel', event => {event.preventDefault();this.viewer.close();}, {signal});
      this.viewer.addEventListener('keydown', event => {
        if (event.key === 'Escape') {event.preventDefault();this.viewer.close();return;}
        if (event.target.closest('input,select,textarea,.nut-watch-product')) return;
        if (['ArrowDown','PageDown','ArrowUp','PageUp'].includes(event.key)) {
          event.preventDefault();this.stepViewer(['ArrowDown','PageDown'].includes(event.key) ? 1 : -1);
        }
      }, {signal});
      this.viewer.addEventListener('wheel', event => {
        if (event.target.closest('.nut-watch-product') || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
        event.preventDefault();
        if (performance.now() < (this.viewerGestureUntil || 0)) return;
        this.viewerWheel = (this.viewerWheel || 0) + event.deltaY;
        clearTimeout(this.viewerWheelTimer);
        this.viewerWheelTimer = setTimeout(() => {this.viewerWheel=0;},160);
        if (Math.abs(this.viewerWheel) >= 45) {this.stepViewer(this.viewerWheel > 0 ? 1 : -1);this.viewerWheel=0;this.viewerGestureUntil=performance.now()+550;}
      }, {passive:false,signal});
      this.viewerMedia.addEventListener('pointerdown', event => {
        if (event.target.closest('button')) return;
        this.viewerMedia.setPointerCapture(event.pointerId);
        this.viewerTouch = {x:event.clientX,y:event.clientY,id:event.pointerId,time:performance.now()};
      }, {signal});
      this.viewerMedia.addEventListener('pointerup', event => {
        const touch=this.viewerTouch;this.viewerTouch=null;
        if (!touch || touch.id !== event.pointerId) return;
        const dy=touch.y-event.clientY,dx=touch.x-event.clientX;
        if (Math.abs(dy) >= 60 && Math.abs(dy) > Math.abs(dx)*1.3) {
          this.viewerIgnoreClickUntil=performance.now()+350;
          this.stepViewer(dy > 0 ? 1 : -1);
        }
      }, {signal});
      this.viewerMedia.addEventListener('pointercancel', () => {this.viewerTouch=null;}, {signal});
      this.viewerMedia.addEventListener('click', event => {
        if(performance.now() < (this.viewerIgnoreClickUntil || 0)){event.preventDefault();event.stopPropagation();}
      }, {capture:true,signal});
      ['play','pause'].forEach(name => this.viewerVideo.addEventListener(name, () => {
        const playing=!this.viewerVideo.paused;
        const button=this.viewer.querySelector('[data-viewer-play]');
        button.classList.toggle('is-paused',!playing);
        button.setAttribute('aria-label',this.dir === 'rtl' ? (playing ? 'إيقاف الفيديو مؤقتًا' : 'تشغيل الفيديو') : (playing ? 'Pause video' : 'Play video'));
        button.querySelector('span').textContent=playing ? 'Ⅱ' : '▶';
      }, {signal}));
      this.viewerVideo.addEventListener('error', () => {if(this.viewer.open)this.viewer.querySelector('.nut-watch-viewer-error').hidden=false;}, {signal});
      document.addEventListener('visibilitychange', () => this.syncViewerPlayback(), {signal});
      this.cards.forEach(card => {
        card.querySelector('[data-open-video]')?.addEventListener('click', event => this.openViewer(card,event.currentTarget), {signal});
      });
    }
    openViewer(card,opener) {
      if (!card.querySelector('video') || card.hidden || this.viewer.open) return;
      this.viewerCards=this.visibleCards().filter(c => c.querySelector('video'));
      this.viewerIndex=this.viewerCards.indexOf(card);
      this.viewerOpener=opener;
      this.viewerMuted=false;
      this.viewerPlaying=true;
      this.viewerScrollLock=document.body.style.overflow;
      document.body.style.overflow='hidden';
      this.videos.forEach(video=>video.pause());
      this.products.forEach(state=>this.closeProduct(state,true));
      this.viewer.showModal();
      this.showViewer(this.viewerIndex);
      if(!this.reduced.matches)this.viewer.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:220,easing:'cubic-bezier(.22,1,.36,1)'});
      this.viewer.querySelector('[data-viewer-close]').focus();
    }
    restoreViewerProduct() {
      const state=this.viewerState;
      if (!state) return;
      state.summary.disabled=this.viewerSummaryDisabled;
      this.viewerPlaceholder?.replaceWith(state.panel);
      this.viewerState=null;
      this.viewerCard=null;
      this.closeProduct(state,true);
    }
    showViewer(index,direction=0) {
      const card=this.viewerCards[index];
      if (!card) return;
      this.viewerVideo.pause();
      this.restoreViewerProduct();
      this.viewerIndex=index;this.viewerCard=card;this.viewerPlaying=true;
      const preview=card.querySelector('video');
      const poster=card.querySelector('.nut-watch-poster');
      if(poster?.currentSrc || poster?.src)this.viewerVideo.poster=poster.currentSrc || poster.src;
      else this.viewerVideo.removeAttribute('poster');
      this.viewerVideo.setAttribute('aria-label',preview.getAttribute('aria-label') || 'Video');
      this.viewerVideo.src=preview.dataset.src;
      this.viewerVideo.muted=this.viewerMuted;
      this.viewerVideo.loop=true;
      this.viewerVideo.load();
      this.viewer.querySelector('.nut-watch-viewer-error').hidden=true;
      const state=this.products.get(card);
      if(state){
        this.viewerPlaceholder=document.createComment('NUT product panel');
        state.panel.before(this.viewerPlaceholder);
        this.viewerState=state;
        this.viewerSummaryDisabled=state.summary.disabled;
        this.viewer.querySelector('[data-viewer-product]').append(state.panel);
        state.summary.disabled=true;state.manualClosed=false;
        this.openProduct(state);
      }
      this.viewer.querySelector('[data-viewer-title]').textContent=preview.getAttribute('aria-label') || '';
      this.viewer.querySelector('[data-viewer-count]').textContent=`${index+1} / ${this.viewerCards.length}`;
      this.viewer.querySelector('[data-viewer-step="-1"]').disabled=index === 0;
      this.viewer.querySelector('[data-viewer-step="1"]').disabled=index === this.viewerCards.length-1;
      this.viewer.querySelector('[data-viewer-hint]').hidden=this.viewerCards.length < 2;
      this.updateViewerSound();
      this.syncViewerPlayback();
      if(direction && !this.reduced.matches)this.viewerMedia.animate([{opacity:.45,transform:`translateY(${direction*22}px)`},{opacity:1,transform:'translateY(0)'}],{duration:220,easing:'cubic-bezier(.22,1,.36,1)'});
    }
    stepViewer(direction) {
      if(!this.viewer.open || this.viewerState?.busy) return;
      const next=this.viewerIndex+direction;
      if(next >= 0 && next < this.viewerCards.length)this.showViewer(next,direction);
    }
    updateViewerSound() {
      const button=this.viewer.querySelector('[data-viewer-sound]');
      const label=this.viewerMuted ? button.dataset.offLabel : button.dataset.onLabel;
      button.setAttribute('aria-pressed',String(!this.viewerMuted));
      button.setAttribute('aria-label',label);
      button.querySelector('[data-sound-label]').textContent=label;
    }
    syncViewerPlayback() {
      if(!this.viewer?.open || document.hidden || !this.viewerPlaying || this.viewerState?.busy)this.viewerVideo?.pause();
      else this.viewerVideo.play().catch(()=>{this.viewerPlaying=false;this.viewerVideo.pause();});
    }

    setupProducts(signal) {
      this.hoverDevice = matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)');
      this.productResize = new ResizeObserver(entries => entries.forEach(entry => {
        const card = entry.target.closest('.nut-watch-card');
        card?.style.setProperty('--nut-product-height',`${Math.ceil(entry.target.getBoundingClientRect().height)}px`);
      }));
      this.cards.forEach(card => {
        const panel = card.querySelector('.nut-watch-product');
        if (!panel) return;
        let variants;
        try { variants = JSON.parse(panel.querySelector('.nut-watch-variant-data').textContent); }
        catch { panel.dataset.failed = 'true';return; }
        const state = {
          card,panel,variants,open:false,busy:false,success:false,manualClosed:false,
          summary:panel.querySelector('.nut-watch-product-summary'),
          details:panel.querySelector('.nut-watch-details'),
          form:panel.querySelector('[data-add-form]'),
          button:panel.querySelector('.nut-watch-atc'),
          status:panel.querySelector('.nut-watch-add-status'),
          selected:variants.find(v => String(v.id) === panel.dataset.defaultVariant) || variants.find(v => v.available) || variants[0]
        };
        this.products.set(card,state);
        this.productResize.observe(panel);
        this.setVariant(state,state.selected.id,false);
        state.summary.addEventListener('pointerdown', () => {state.openBeforePointer=state.open;},{signal});
        state.summary.addEventListener('click', event => {
          const wasOpen = event.detail > 0 ? state.openBeforePointer : state.open;
          if (wasOpen) {state.manualClosed=true;this.closeProduct(state,true);}
          else {state.manualClosed=false;this.openProduct(state);}
        },{signal});
        panel.querySelector('[data-close-product]').addEventListener('click', () => {
          state.manualClosed=true;this.closeProduct(state,true);state.summary.focus();
        },{signal});
        card.addEventListener('pointerenter', () => {
          if (this.hoverDevice.matches && this.dataset.hover === 'true') {state.manualClosed=false;this.openProduct(state);}
        },{signal});
        card.addEventListener('pointerleave', () => this.scheduleProductClose(state),{signal});
        panel.addEventListener('focusin', () => {
          clearTimeout(state.closeTimer);
          if (!state.manualClosed) this.openProduct(state);
        },{signal});
        panel.addEventListener('focusout', event => {
          if (panel.contains(event.relatedTarget)) return;
          state.manualClosed=false;this.scheduleProductClose(state);
        },{signal});
        panel.addEventListener('keydown', event => {
          if (event.key === 'Escape') {event.preventDefault();if(this.viewer?.open){this.viewer.close();return;}state.manualClosed=true;this.closeProduct(state,true);state.summary.focus();}
        },{signal});
        panel.querySelectorAll('[data-variant-id]').forEach(button => button.addEventListener('click', () => {
          if (!state.busy) this.setVariant(state,button.dataset.variantId);
        },{signal}));
        panel.querySelector('[data-variant-select]')?.addEventListener('change', event => {
          if (!state.busy) this.setVariant(state,event.target.value);
        },{signal});
        state.form.addEventListener('submit', event => {event.preventDefault();this.addVariant(state);},{signal});
      });
      document.addEventListener('pointerdown', event => {
        if (!this.hoverDevice.matches && !event.target.closest('.nut-watch-product')) this.products.forEach(state => this.closeProduct(state,true));
      },{signal});
    }
    openProduct(state) {
      clearTimeout(state.closeTimer);
      this.products.forEach(other => {if(other !== state) this.closeProduct(other,true);});
      state.open=true;state.details.inert=false;
      state.panel.classList.add('is-open');
      state.summary.setAttribute('aria-expanded','true');
    }
    scheduleProductClose(state) {
      clearTimeout(state.closeTimer);
      state.closeTimer=setTimeout(() => {
        if(this.viewer?.open && this.viewerCard === state.card)return;
        const hovered = this.hoverDevice.matches && state.card.matches(':hover');
        if (!hovered && !state.panel.contains(document.activeElement) && !state.busy) this.closeProduct(state);
      },150);
    }
    closeProduct(state,force=false) {
      if(this.viewer?.open && this.viewerCard === state.card)return;
      clearTimeout(state.closeTimer);
      if (state.busy && !force) return;
      state.open=false;state.details.inert=true;
      state.panel.classList.remove('is-open');
      state.summary.setAttribute('aria-expanded','false');
    }
    setVariant(state,id,animate=true) {
      const variant=state.variants.find(v => String(v.id) === String(id));
      if (!variant || state.busy) return;
      state.selected=variant;state.success=false;
      clearTimeout(state.successTimer);
      state.status.hidden=true;state.status.classList.remove('is-error');
      state.form.querySelector('[name=id]').value=String(variant.id);
      state.panel.querySelectorAll('[data-variant-id]').forEach(button => {
        const option=state.variants.find(v => String(v.id) === button.dataset.variantId);
        button.setAttribute('aria-pressed',String(button.dataset.variantId === String(id)));
        button.disabled=!option?.available;
      });
      const select=state.panel.querySelector('[data-variant-select]');
      if(select) select.value=String(variant.id);
      const price=state.panel.querySelector('[data-variant-price]');
      price.textContent=variant.formattedPrice;
      state.panel.querySelector('[data-add-price]').textContent=variant.formattedPrice;
      const image=state.panel.querySelector('.nut-watch-product-image');
      if(image && variant.image) {image.removeAttribute('srcset');image.src=variant.image;}
      if(animate && !this.reduced.matches) price.animate([{opacity:.4},{opacity:1}],{duration:160});
      this.renderAddButton(state);
    }
    renderAddButton(state) {
      const label=state.busy ? state.panel.dataset.loadingLabel : state.success ? state.panel.dataset.addedLabel : state.selected.available ? state.panel.dataset.addLabel : state.panel.dataset.soldLabel;
      state.button.querySelector('[data-add-text]').textContent=label;
      state.button.querySelector('[data-add-price]').hidden=state.busy || state.success || !state.selected.available;
      state.button.disabled=state.busy || state.success || !state.selected.available;
      state.button.setAttribute('aria-busy',String(state.busy));
      state.button.classList.toggle('is-added',state.success);
      state.panel.querySelectorAll('[data-variant-id]').forEach(button => {
        const option=state.variants.find(v => String(v.id) === button.dataset.variantId);
        button.disabled=state.busy || !option?.available;
      });
      const select=state.panel.querySelector('[data-variant-select]');
      if(select) select.disabled=state.busy;
    }
    async addVariant(state) {
      if(state.busy || state.success || !state.selected.available) return;
      state.busy=true;state.status.hidden=true;state.status.classList.remove('is-error');
      this.renderAddButton(state);
      state.card.querySelector('video')?.pause();
      if(this.viewerCard === state.card)this.viewerVideo.pause();
      const variantId=String(state.selected.id);
      try {
        this.eventsPromise ||= import('@theme/events');
        const events=await this.eventsPromise;
        const drawer=document.querySelector('[ref="hdt-cart"]');
        const sectionId=drawer?.getAttribute('section-id');
        const form=new FormData();
        form.set('id',variantId);form.set('quantity','1');
        if(sectionId) {form.set('sections',sectionId);form.set('sections_url',location.pathname);}
        const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:form});
        const result=await response.json();
        if(!response.ok || result.status) throw new Error(result.description || result.message || state.panel.dataset.errorLabel);
        // Updating sections follows the theme contract; 'none' keeps the visitor in the video row.
        if(sectionId && result.sections?.[sectionId]) {
          const event=new events.CartAddEvent({},variantId,result,'none','product-form-component',{itemCount:1,productId:state.panel.dataset.productId,variantId,sections:result.sections});
          (this.isConnected ? this : document).dispatchEvent(event);
        } else document.dispatchEvent(new CustomEvent('cart:reload'));
        state.success=true;
        state.status.textContent=state.panel.dataset.addedLabel;state.status.hidden=false;
        this.status.textContent=`${state.panel.dataset.addedLabel} · ${state.selected.title}`;
        state.successTimer=setTimeout(() => {state.success=false;state.status.hidden=true;this.renderAddButton(state);},2000);
      } catch(error) {
        state.status.textContent=error.message || state.panel.dataset.errorLabel;
        state.status.classList.add('is-error');state.status.hidden=false;
        this.status.textContent=state.status.textContent;
      } finally {
        state.busy=false;this.renderAddButton(state);
        const video=state.card.querySelector('video');if(video) this.syncPlayback(video);
        this.syncViewerPlayback();
        if(!state.open) this.closeProduct(state,true);
      }
    }

    disconnectedCallback() {
      if(this.viewer?.open){this.viewerVideo.pause();this.viewer.close();this.restoreViewerProduct();document.body.style.overflow=this.viewerScrollLock || '';}
      clearTimeout(this.viewerWheelTimer);
      clearTimeout(this.filterTimer);this.abort?.abort();this.abort = null;
      this.visibleObserver?.disconnect();this.revealObserver?.disconnect();this.resize?.disconnect();this.modalObserver?.disconnect();
      this.animations?.forEach(animation=>animation.cancel());this.videos?.forEach(video=>video.pause());
      this.productResize?.disconnect();
      this.products?.forEach(state => {clearTimeout(state.closeTimer);clearTimeout(state.successTimer);});
      delete this.dataset.motionReady;delete this.dataset.enhanced;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
